<template>
  <div class="select-button">

    <Select v-model="modelValueHandler"
            :options="options"
            :placeholder="placeholder"
            class="select-button__select"
            />

    <Button :icon="icon"
            :iconPosition="iconPosition"
            class="select-button__button"
    >
      {{valuePrefix}} {{valueTitle}}
    </Button>

  </div>
</template>

<script>
import Button from '@/components/UI/Button.vue';
import Select from '@/components/UI/Select.vue';

export default {
  name: 'SelectButton',

  components: {
    Button,
    Select,
  },

  props: {
    modelValue: {
      type: String,
    },
    icon: {
      type: String,
    },
    iconPosition: {
      type: String,
    },
    options: {
      type: Object,
      required: true,
    },
    placeholder: {
      type: String,
    },
    valuePrefix: {
      type: String,
    },
  },

  computed: {
    modelValueHandler: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },

    valueTitle() {
      const currentOption = this.options.find((option) => option.id === this.modelValue);
      return currentOption !== undefined ? currentOption.title : this.placeholder;
    },
  },
};
</script>

<style lang="scss" scoped>
  .select-button {
    position: relative;

    &__select {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      overflow: hidden;
    }

    &__button {
      justify-content: flex-start;
      width: 100%;
    }
  }
</style>
